import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import type { SystemStatusResponse } from '@onedv-portal/api'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class SystemStatusService {
  private readonly http = inject(HttpClient)

  getStatus(): Observable<SystemStatusResponse> {
    return this.http.get<SystemStatusResponse>(`${environment.apiUrl}/system-status`)
  }
}
